import { Alert, Button, Paper, Stack, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CloseIcon from '@mui/icons-material/Close'

const AdministrationActions = ({
  canSubmit,
  canReuse,
  amountMLs,
  selectedDrugsAdministered,
  drugName,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  const quantityText = canReuse
    ? `${amountMLs || 0}ml`
    : `${selectedDrugsAdministered.length}x`

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 3,
        // position: 'sticky',
        bottom: 16,
        zIndex: 5,
        bgcolor: 'background.paper',
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.12)',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
      >
        <Stack spacing={0.5}>
          <Typography fontWeight={800}>Ready to record?</Typography>

          {canSubmit ? (
            <Typography variant="body2" color="text.secondary">
              Confirm administration of <strong>{quantityText}</strong>{' '}
              <strong>{drugName}</strong>.
            </Typography>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Select a medicine, batch, and dose details to continue.
            </Typography>
          )}
        </Stack>

        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            color="error"
            startIcon={<CloseIcon />}
            onClick={onClose}
            disabled={!!isSubmitting}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700 }}
          >
            Close
          </Button>

          <Button
            variant="contained"
            startIcon={<CheckCircleIcon />}
            disabled={!canSubmit || !!isSubmitting}
            onClick={onSubmit}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 800 }}
          >
            Confirm
          </Button>
        </Stack>
      </Stack>

      {canSubmit && (
        <Alert severity="warning" variant="outlined" sx={{ mt: 2 }}>
          Please check the medicine, batch, dose and patient details before
          confirming. This action creates an audit record.
        </Alert>
      )}
    </Paper>
  )
}

export default AdministrationActions
